<template>
    <div class="utility-callout-wrapper xl:w-tabletSize md:w-w600 ml-auto mr-auto flex items-center px-spc15 mb-spc16 bottom-0 relative z-10">
        <div class="callout-item w-2/6 pr-5 xl:text-left md:text-center">
            <h1 class="callout-title flex items-end text-size28 font-semibold text-white h-12 xl:justify-start md:justify-center">
                351<span class="pl-1 text-2xl">mi</span>
            </h1>
            <p class="callout-desc text-xs font-normal leading-spc3 text-white">
                Go anywhere with up to 351 miles of range on a single charge
            </p>
            <p class="callout-desc rp text-xs font-normal leading-spc3 text-white hidden">
                Range
            </p>
        </div>
        <div class="callout-item w-2/6 px-5 xl:text-left md:text-center">
            <h1 class="callout-title flex items-center text-size28 font-semibold text-white h-12 xl:justify-start md:justify-center">
                15<span class="pl-1 text-2xl">min</span>
            </h1>
            <p class="callout-desc text-xs font-normal leading-spc3 text-white">
                Recharge up to 123 miles in 15 <br>minutes at any Supercharger <br>location
            </p>
            <p class="callout-desc rp text-xs font-normal leading-spc3 text-white hidden">
                Recharge <br>123 miles
            </p>
        </div>
        <div class="callout-item w-2/6 pl-5 xl:text-left md:text-center">
            <h1 class="callout-title flex items-center text-size28 font-semibold text-white h-12 xl:justify-start md:justify-center">
                16,000+
            </h1>
            <p class="callout-desc text-xs font-normal leading-spc3 text-white">
                Superchargers placed along well-traveled routes around the world
            </p>
            <p class="callout-desc rp text-xs font-normal leading-spc3 text-white hidden">
                Superchargers
            </p>
        </div>

    </div>
</template>

<script>
    export default {
        name: "RangeSpecs"
    }
</script>

<style scoped>

</style>